(function(){
  function onReady(fn){ if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', fn); } else { fn(); } }
  function pad(n){ return n < 10 ? '0' + n : '' + n; }

  function initCountdown(el){
    if (!el || el.__urgencyBound) return;
    el.__urgencyBound = true;

    var cutoffHour = parseInt(el.getAttribute('data-cutoff-hour'));
    var cutoffMinute = parseInt(el.getAttribute('data-cutoff-minute'));
    var hideAfter = String(el.getAttribute('data-hide-after-cutoff')).toLowerCase() === 'true';

    if (isNaN(cutoffHour)) cutoffHour = 14; // default 2pm
    if (isNaN(cutoffMinute)) cutoffMinute = 0;

    var out = el.querySelector('[data-countdown]');
    if (!out) return;

    function update(){
      try {
        var now = new Date();
        var cutoff = new Date(now);
        cutoff.setHours(cutoffHour, cutoffMinute, 0, 0);

        var ms = cutoff.getTime() - now.getTime();
        if (ms <= 0){
          if (hideAfter){
            el.style.display = 'none';
          } else {
            // If not hiding after cutoff, show zeroed countdown
            out.textContent = '0h 00m 00s';
          }
          return;
        }

        var totalSeconds = Math.floor(ms / 1000);
        var hours = Math.floor(totalSeconds / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;

        out.textContent = hours + 'h ' + pad(minutes) + 'm ' + pad(seconds) + 's';
        el.style.display = '';
      } catch(_) {}
    }

    update();
    var timer = setInterval(update, 1000);
    el.__urgencyCleanup = function(){ try { clearInterval(timer); } catch(_) {} };
  }

  function initAll(scope){
    var root = scope || document;
    var els = root.querySelectorAll('[data-urgency-countdown]');
    els.forEach(initCountdown);
  }

  onReady(function(){
    initAll(document);

    // Observe DOM changes to initialize countdowns added later (e.g., section re-render)
    try {
      var mo = new MutationObserver(function(mutations){
        mutations.forEach(function(m){
          if (m.addedNodes) {
            m.addedNodes.forEach(function(n){
              if (n.nodeType === 1){
                if (n.matches && n.matches('[data-urgency-countdown]')) initCountdown(n);
                else initAll(n);
              }
            });
          }
          if (m.removedNodes) {
            m.removedNodes.forEach(function(n){
              if (n && n.__urgencyCleanup) n.__urgencyCleanup();
            });
          }
        });
      });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch(_) {}
  });
})();
